import React, {Component} from 'react'
import Grid from "../../../Utils/Grid";
import {TableHeaderColumn} from "react-bootstrap-table";
import {standardActions} from "../../../Utils/Grid/StandardActions";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";

export default class RequerimientosList extends Component{
    componentWillMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;
        return(
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="Requerimientos"
                    subtitulo="">
                    <Header to="requerimiento/crear" textBtn="CREAR REQUERIMIENTO" {...this.props} />
                    <Grid hover striped data={data} loading={loader} page={page} onPageChange={onPageChange}>
                        <TableHeaderColumn
                            dataField="id"
                            dataSort
                            width='20%'
                        >
                            ID
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            isKey
                            dataField="nombre"
                            dataSort
                            width='20%'
                        >
                            Nombre
                        </TableHeaderColumn>
                      
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "requerimiento", eliminar})}
                        >
                            Acciones
                        </TableHeaderColumn>



                    </Grid>
                </Card>
            </div>
        )
    }
}
